export type Service = {
  title: string
  description: string
  details: string[]
  icon: 'key' | 'lock' | 'shield' | 'door' | 'wrench'
  featured?: boolean
}

export const services: Service[] = [
  {
    title: 'Ouverture de porte claquée ou fermée',
    description:
      "Porte claquée, clé cassée dans le cylindre, clé perdue : j'interviens sans dégrader la porte dans la très grande majorité des cas.",
    details: [
      'Ouverture fine sans perçage quand la serrure le permet',
      'Remplacement du cylindre immédiat si nécessaire',
      'Devis annoncé au téléphone avant tout déplacement',
    ],
    icon: 'key',
    featured: true,
  },
  {
    title: 'Changement de serrure et de cylindre',
    description:
      'Remplacement à l’identique ou montée en gamme vers un cylindre certifié A2P, avec clés protégées contre la reproduction.',
    details: ['Cylindres A2P 1, 2 et 3 étoiles', 'Mise en passe d’un immeuble ou d’un local'],
    icon: 'lock',
  },
  {
    title: 'Blindage et portes de sécurité',
    description:
      'Blindage de porte existante, bloc-porte blindé, serrure multipoints : après effraction ou en prévention.',
    details: ['Serrures 3 et 5 points', 'Cornière anti-pince et pênes renforcés'],
    icon: 'shield',
  },
  {
    title: 'Dépannage après effraction',
    description:
      'Sécurisation immédiate de l’ouverture, remise en état de la porte et fourniture des documents pour votre assurance.',
    details: ['Mise en sécurité le jour même', 'Facture détaillée pour le sinistre'],
    icon: 'door',
  },
  {
    title: 'Volets, rideaux et grilles',
    description:
      'Rideau métallique bloqué, volet roulant hors service, grille de commerce : réparation ou remplacement du mécanisme.',
    details: ['Commerces et locaux professionnels', 'Motorisation et serrures de rideau'],
    icon: 'wrench',
  },
]
